module.exports = __webpack_public_path__ + "img/dd_city_logo.8f70c2e7.png";